<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
        { label: 'ACCESOS' }]">
      </app-breadcrumb>
    </div>

    <app-top-widgets/>

    <div class="row clearfix">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <mat-tab-group
            data-tour="accesos-tabs"
            [selectedIndex]="selectedTabIndex"
            (selectedIndexChange)="selectedTabIndex = $event">

            <mat-tab *ngIf="!isSpain">
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon msr-2">supervised_user_circle</mat-icon>
                TIPOS DE USUARIO
              </ng-template>
              <ng-template matTabContent>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="project_widget">
                    <div class="body">
                      <app-user-type/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <span data-tour="accesos-tab-groups">
                  <mat-icon class="example-tab-icon msr-2">business_center</mat-icon>
                  GRUPOS EMPRESARIALES
                </span>
              </ng-template>
              <ng-template matTabContent>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="project_widget">
                    <div class="body">
                      <app-groups/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon msr-2">opacity</mat-icon>
                EVENTOS DE SALUD
              </ng-template>
              <ng-template matTabContent>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="project_widget">
                    <div class="body">
                      <app-health-events/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-tab>

          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</section>
